import { TFunction } from 'i18next'

import { RecurringInvoiceDelivery } from '@features/recurringInvoices/enums/recurringInvoiceDelivery'
import { RecurringInvoiceDuration } from '@features/recurringInvoices/enums/recurringInvoiceDuration'
import { RecurringInvoiceFrequency } from '@features/recurringInvoices/enums/recurringInvoiceFrequency'

interface GetRecurringInvoiceFormDefaultValuesOptions {
  isStripeCardPaymentActive?: boolean
  organizationName: string
  t: TFunction
}

export const getRecurringInvoiceFormDefaultValues = ({
  isStripeCardPaymentActive = false,
  organizationName,
  t,
}: GetRecurringInvoiceFormDefaultValuesOptions) => {
  const today = new Date()
  return {
    delivery: RecurringInvoiceDelivery.Create,
    deliveryNotification: true,
    duration: RecurringInvoiceDuration.Repeat,
    firstInvoiceDate: today,
    frequency: RecurringInvoiceFrequency.Monthly,
    message: {
      body: t(
        'external_invoices.editor.form.recurring_invoice_settings.email_template.modal.field.email_message.default_text',
        { organizationName },
      ),
      to: [],
      acceptStripePayment: isStripeCardPaymentActive,
    },
    occurrences: 5,
  }
}
